<template>
	
	<div v-if="merchandising.content && merchandising.content[ type ]" class="g-searchspring__merchandising">
		<div v-for="(banner, index) in merchandising.content[ type ]" :key="index" :class="{['is-' + type]: true, 'u-mt-s u-mt--m': type === 'banner'}" class="g-searchspring__banner u-mb-s u-mb--m">
			<div v-html="banner"></div>
		</div>
	</div>

</template>

<script>

	export default {
		props: {
			merchandising: {
				default() {
					return {}
				}
			},
			type: {
				type: String
			}
		}
	}

</script>
